import { createModel } from '@/store/tools';

const model = {
    namespace: 'accountstatement',
    build: (T, A, S, R) => ({
        actiontypes: {
            'getStateList': T('getStateList'), // 状态
            'getTableSource': T('getTableSource'), // 对账明细列表
            'getDetail': T('getDetail'), // 详情
            'getQueryReconciliations': T('getQueryReconciliations'), // 列表
            'getOpearationList': T('getOpearationList'), // 运营公司列表
        },
        actions: {
            'getStateList': A('getStateList'),
            'getTableSource': A('getTableSource'),
            'getDetail': A('getDetail'),
            'getQueryReconciliations': A('getQueryReconciliations'),
            'getOpearationList': A('getOpearationList'),
        },
        sagas: {
            'getStateList': S('getStateList', '/?cmd=com.xqxc.api.pig.mis.reconciliation.ReconciliationApiMisService.getReconciliationStatus'),
            'getTableSource': S('getTableSource', '/?cmd=com.xqxc.api.pig.mis.reconciliation.ReconciliationApiMisService.queryReconciliationItems'),
            'getDetail': S('getDetail', '/?cmd=com.xqxc.api.pig.mis.reconciliation.ReconciliationApiMisService.getReconciliationDetail'),
            'getQueryReconciliations': S('getQueryReconciliations', '/?cmd=com.xqxc.api.pig.mis.reconciliation.ReconciliationApiMisService.queryReconciliations'),
            'getOpearationList': S('getOpearationList', '/?cmd=com.xqxc.api.pig.mis.reconciliation.ReconciliationApiMisService.getOpearationList'),
        },
        reducers: {
            'stateList': R('getStateList', []),
            'tableSource': R('getTableSource', { dataList: [], pageNum: 1, pageSize: 25, resultTotal: 0 }),
            'detail': R('getDetail', {}),
            'QueryReconciliations': R('getQueryReconciliations', { dataList: [], pageNum: 1, pageSize: 25, resultTotal: 0 }),
            'OpearationList': R('getOpearationList', []),
        }
    })
};
export default createModel(model);